import { Pipe, PipeTransform } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';

import { isNullOrUndefined } from '@app/util/util';
import { AirValidationResponse } from '@app/entities/air-validation.response';
import { Price } from '@app/entities/price';
import { HotelValidationResponse } from '@booking/entities/hotel-validation.response';

@Pipe({
  name: 'airPackagePrice',
  standalone: false
})
export class AirPackagePricePipe implements PipeTransform {

  transform(air: AirValidationResponse, hotel: HotelValidationResponse): Price {
    return getAirPackagePrice(air, hotel);
  }
}

export function getAirPackagePrice(air: AirValidationResponse, hotel: HotelValidationResponse): Price {
  const airPrice = air?.TripOption?.Price;
  const hotelAmounts = hotel?.HotelReservation?.Price;
  if (!isEmpty(airPrice) || !isEmpty(hotelAmounts)) {
    return {
      Amount: getValue(airPrice.Amount, hotelAmounts.Amount),
      Taxes: getValue(airPrice.Taxes as number, hotelAmounts.Taxes as number),
      Fees: getValue(airPrice.Fees, hotelAmounts.Fees),
      DiscountAmount: getValue(airPrice.DiscountAmount, hotelAmounts.DiscountAmount),
      CommissionAmount: getValue(airPrice.CommissionAmount, hotelAmounts.CommissionAmount),
      CurrencyCode: airPrice.CurrencyCode,
      Surcharges: getValue(airPrice.Surcharges, hotelAmounts.Surcharges),
      Total: getValue(airPrice.Total, hotelAmounts.Total),
      TotalFareCalculated: getValue(airPrice.TotalFareCalculated, hotelAmounts.Fare),
      DiscountPercentageCalculated: getValue(airPrice.DiscountPercentageCalculated, hotelAmounts.DiscountAmount),
      PenaltyAmount: getValue(airPrice.PenaltyAmount, null)
    };
  } else return {} as Price;
}

function getValue(airValue: number, hotelValue: number): number {
  const air = !isNullOrUndefined(airValue) ? airValue : 0;
  const hotel = !isNullOrUndefined(hotelValue) ? hotelValue : 0;
  return air || hotel;
}
